import React from "react";

export function SectionLabel({ number, label }) {
  return (
    <div className="flex items-center gap-3 text-[11px] tracking-[0.3em] uppercase">
      <span className="sec-num">{number}</span>
      <span className="h-px w-10 bg-[rgba(212,169,73,0.55)]" />
      <span className="text-[rgb(var(--bone-dim))]">{label}</span>
    </div>
  );
}

export function SectionHeading({ children, className = "" }) {
  return (
    <h2
      className={`font-serif-display font-medium text-5xl sm:text-6xl lg:text-7xl leading-[1.02] text-[rgb(var(--bone))] ${className}`}
    >
      {children}
    </h2>
  );
}
